'use strict';
var ClassNames = require('classnames');

//Utilities
var React = require('react');

var TextInputHelper = React.createClass({
    render: function () {
        return (
            <div className={ClassNames('helper',{'ui-helper-hidden-accessible': this.props.isHidden})}>
                Press <strong>Tab</strong> to continue
            </div>
          
        );
    }
});

module.exports = TextInputHelper;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Common/TextInputHelper.jsx